/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// Components
import { NewCardButton } from 'components/CardButtons'
import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'
import { useAdvanceSuccess, useCommercialOffer } from 'store'
import LoanInformation from 'components/LoanInformation'
import { SuccessIcon, DelayIcon } from 'assets/icons'
import { hasActiveMembership } from 'utils'
import { trackEvent } from 'analytics/trackFunctions'
import { MeContext } from 'contexts/me'
import { CREDIT_TYPES } from 'constants/credit'
import Badge from 'components/Badge'
import { toLocaleCurrency } from 'utils/dinero'

const FinishAdvance = () => {
  const navigate = useNavigate()
  const { me } = useContext(MeContext)
  const { amount, hasSubscribed, advanceType, isDelayed } = useAdvanceSuccess()
  const { updateToDefault } = useCommercialOffer()

  useEffect(() => {
    if (advanceType === CREDIT_TYPES.ZERO_RATE) {
      trackEvent({
        eventName: 'bille_pantalla_adelantos_oferta_comercial_tasa_0_exito'
      })
    } else {
      trackEvent({ eventName: 'bille_adelantos_oferta_confirmacion' })
    }

    updateToDefault()
  }, [])

  const cardContent = () => {
    if (hasSubscribed) {
      return (
        <>
          <p className='font-bold text-purple-900'>
            Ahora tenés Wayni<span className='text-green-800'>+</span>
          </p>
          <p className='text-medium text-xs text-black'>
            Empezá a disfrutar los beneficios
          </p>
        </>
      )
    }
    if (hasActiveMembership(me?.subscriber_products)) {
      return (
        <>
          <p className='font-bold text-purple-900'>
            Usaste tu membresía Wayni<span className='text-green-800'>+</span>
          </p>
          <p className='text-medium text-xs text-black'>
            Seguí conociendo todos tus beneficios.
          </p>
        </>
      )
    }
    return (
      <>
        <p className='font-bold text-purple-900'>
          Suscribite a Wayni<span className='text-green-800'>+</span>
        </p>
        <p className='text-medium text-xs text-black'>
          Para más adelantos, solicitá tu membresía.
        </p>
      </>
    )
  }

  const headerContent = () => {
    if (isDelayed)
      return (
        <>
          <DelayIcon className='mx-auto !w-32 !h-32' />
          <div className='text-xl text-center font-bold mt-8 leading-[1.375rem]'>
            <p>Estamos con demoras en el servicio.</p>
            <p>
              Tu adelanto de ${toLocaleCurrency(amount)} está siendo procesado.
            </p>
          </div>
        </>
      )

    return (
      <>
        <SuccessIcon className='mt-8' />
        <h1 className='font-bold text-xl text-center mt-8 mb-1'>
          ¡Listo! <br /> ¡Pronto verás{' '}
          {amount ? `$${toLocaleCurrency(amount)}` : 'el adelanto'} en tu
          billetera!
        </h1>
        {advanceType === CREDIT_TYPES.ZERO_RATE && (
          <Badge variant='GRADIENT_GREEN' className='my-1'>
            <span>Hiciste uso de tu adelanto tasa 0</span>
          </Badge>
        )}
      </>
    )
  }

  return (
    <PageWrapper noTabBar title='Adelantos' viewSelected='/adelantos'>
      <section className='flex flex-col items-center mx-auto text-black sm:max-w-[22.5rem]'>
        {headerContent()}
        <p className='text-center font-medium mt-1'>
          Usá tu dinero con tu tarjeta Wayni 💳 <br />
          comprando en tiendas físicas y virtuales.
        </p>
        <NewCardButton
          className='my-9'
          onClick={() => navigate('/suscripcion')}
        >
          {cardContent()}
        </NewCardButton>
        <PrimaryButton
          className='mb-4'
          buttonText='Ir al inicio'
          primaryButtonFunction={() => {
            trackEvent({
              eventName: 'bille_adelantos_boton_oferta_confirmacion_volver'
            })
            navigate('/home')
          }}
        />
        <PrimaryButton
          outlined
          className='mb-10'
          buttonText='Pedir otro adelanto'
          primaryButtonFunction={() => {
            trackEvent({
              eventName:
                'bille_adelantos_boton_oferta_confirmacion_nuevo_adelanto'
            })
            navigate('/wayni-credito')
          }}
        />

        <LoanInformation />
      </section>
    </PageWrapper>
  )
}

export default FinishAdvance
